"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nameOf = void 0;
const ts_essentials_1 = require("ts-essentials");
function nameOf(arg) {
    const keys = Object.keys(arg);
    (0, ts_essentials_1.assert)(keys.length === 1, `500|TooManyArgsForNameOf|#length=${keys.length}`);
    return keys.at(0);
}
exports.nameOf = nameOf;
